<template>
  <v-text-field
    ref="input"
    :value="value"
    :maxlength="maxlength"
    dense
    outlined
    :disabled="disabled"
    :label="label"
    :error-messages="errorMessages"
    @input="onInput"
    @focus="$event.target.select()"
    @keydown.native="onKeyDown"
    @keyup.native="onKeyUp"
		@blur="onBlur"
  >
  </v-text-field>
</template>

<script>
import { isNumericKey } from "../../utils/keyboard.js";
import { Backspace } from "../../constants/Keys.js";

const NUMBER_REGEX = /^\d+$/;

export default {
  name: "ResultFieldEditor",
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: String,
      required: false,
      default: ""
    },
    maxlength: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
		onInput(value) {
			const parsedValue = parseInt(value, 10);

			if(!NUMBER_REGEX.test(value) || isNaN(parsedValue) || parsedValue < 0) {
				console.log("Invalid input, resetting to empty string");
				this.$emit("input", "");
			} else {
				this.$emit("input", value);
			}
		},
		onBlur() {
			if (this.value !== ''){
				const parsedValue = parseInt(this.value, 10);
				if (!NUMBER_REGEX.test(this.value) || isNaN(parsedValue) || parsedValue < 0) {
					console.log("Invalid input, resetting to empty string");
					this.$emit("input", "");
				}
			}
		},
    focus() {
      this.$refs.input.focus();
    },
    onKeyDown(event) {
      const isNumeric = isNumericKey(event),
        isBackSpace = event.code === Backspace;

      if (!isNumeric && !isBackSpace) {
        event.preventDefault();
      }
    },
    onKeyUp(event) {
      const isSelected =
        event.target.selectionEnd - event.target.selectionStart ===
        this.maxlength;

      if (event.target.value.length === this.maxlength && !isSelected) {
        this.$emit("complete");
      }
    }
  }
};
</script>

<style scoped></style>
